module.exports = "<p>\n  An error occured in the page you were trying to reach. Please check the url and try again.\n</p>\n"